import { useTranslation } from 'react-i18next';

export const useCopyBlock = (setActiveSelect) => {
    const { t } = useTranslation();
    const $stepBody = $('.estimate-step-body');
    const step = $($stepBody).closest(EM.stepClass);

    const clonePositions = (e, type) => {
        e.stopPropagation();
        setActiveSelect('');
        positionMassEditManager.cloneSelectedPositionsInStep(step);
    };

    const clonePositionsToDirectory = (e) => {
        e.stopPropagation();
        setActiveSelect('');

        const url = routable.getRoute('copyDirectoryPositions');

        $.modalable('open', {
            url,
            shownCallback() {
                $('.copy-positions-to-directory select').select2({
                    language: {
                        noResults() {
                            return t('CopyBlock.useCopyBlock.clonePositions.NoResults.text');
                        },
                    },
                    matcher(params, data) {
                        if ($.trim(params.term) === '') {
                            return data;
                        }
                        if (typeof data.text === 'undefined') {
                            return null;
                        }

                        if (
                            data.text.indexOf(params.term) > -1 ||
                            data.text.indexOf(t('massEditManager.shownCallback.matcher')) > -1
                        ) {
                            return $.extend({}, data, true);
                        }

                        return null;
                    },
                });
            },
        });
    };
    return { clonePositions, clonePositionsToDirectory };
};
